import { CTABannerBasicPlugin } from './CTABannerBasicPlugin';
import { EmbededPlugin } from './EmbededPlugin';
import { EviscoLivestreamPlugin } from './EviscoLivestreamPlugin';
import { GalleryCarouselPlugin } from './GalleryCarouselPlugin';
import {
  CategorizedCarouselListPlugin,
  UncategorizedCarouselListPlugin,
} from './ListCarousel';
import {
  CategorizedHeroListPlugin,
  UncategorizedHeroListPlugin,
} from './ListHeroPlugin';
import { MediaRailPlugin } from './MediaRailPlugin';
import { pluginRegistry } from './PluginRegistry';
import { PodcastBasicPlugin } from './PodcastBasicPlugin';
import { SpotlightBannerPlugin } from './SpotlightBannerPlugin';
import { SpotlightCollectionPlugin } from './SpotlightCollectionPlugin';
import { WysiwygTextBasic } from './WysiwygTextBasic';

pluginRegistry.register(CTABannerBasicPlugin);
pluginRegistry.register(SpotlightBannerPlugin);
pluginRegistry.register(SpotlightCollectionPlugin);
pluginRegistry.register(GalleryCarouselPlugin);
pluginRegistry.register(CategorizedCarouselListPlugin);
pluginRegistry.register(UncategorizedCarouselListPlugin);
pluginRegistry.register(MediaRailPlugin);
pluginRegistry.register(WysiwygTextBasic);
pluginRegistry.register(EmbededPlugin);
pluginRegistry.register(PodcastBasicPlugin);
pluginRegistry.register(EviscoLivestreamPlugin);
pluginRegistry.register(CategorizedHeroListPlugin);
pluginRegistry.register(UncategorizedHeroListPlugin);
